<footer class="w-full bg-[#001c3a] text-white text-sm py-2 px-6 mt-12 flex flex-wrap items-center justify-between gap-3 mt-auto">
    <p>&copy; Legal Resources {{ currentYear }}</p>
    <ng-content></ng-content>
</footer>